export default class Bid {
   constructor(bid = {}, trip = {}) {
      this.id = bid.trip_id + bid.order + bid.rfq_id;
      this.rfqId = bid.rfq_id;
      this.tripId = bid.trip_id;
      this.transporterId = bid.transporter_id;
      this.transporterName = bid.transporter_name;
      this.price = bid.price;
      this.priceINR = bid.price_inr;
      this.priceUSD = bid.price_usd;
      this.priceSecondary = bid.price_secondary;
      this.transporterVol = bid.transporter_business_vol || '';
      this.allowBusinessVolume = bid.allowBusinessVolume || false;
      this.showTat = bid.showTat || false;
      this.qbrShowRate = bid.qbrShowRate || false;
      this.originalPrice = bid.original_price || bid.price;
      this.firstBidPrice = bid.first_bid_price || '';
      this.lastBidPrice = bid.last_bid_price || '';
      this.tat = (bid.tat || {}).value + ' ' + (bid.tat || {}).name;
      this.maxTat = bid.max_tat;
      this.weightedAverage = bid.weighted_average;
      this.serviceAvailability = bid.service_availability;
      this.tatObj = bid.tat;
      this.count = bid.count;
      this.colorCode = bid.color_code;
      this.orderText = bid.order_text;
      this.key = bid.key;
      this.challengePrice = bid.challenge_price;
      this.challengePriceINR = bid.challenge_price_inr;
      this.challengePriceUSD = bid.challenge_price_usd;
      this.challengePriceSecondary = bid.challenge_price_secondary;
      this.isCounter = bid.is_counter;
      this.pricingBasis = bid.pricing_basis;
      this.cpState = bid.cp_state;
      this.counterPrice = bid.counter_price;
      this.counterStatus = bid.counter_status;
      this.business_allocation = bid.business_allocation || 0;

      this.isLoiSent = bid.is_loi_sent;
      this.isLoiWithCPSent = bid.is_loi_with_cp_sent;
      this.isAccept = bid.is_accept;
      this.isLoiAutoAccepted = bid.auto_accepted_loi;

      this.previous = bid.previous;
      this.current = bid.current;
      this.challengePriceDifference = bid.cp_differ || bid.price_differ ;

      this.created = bid.created;

      this.seekerRemarks = bid.seeker_remarks;
      this.seekerSentLoiApproverRemarks = bid.sent_loi_for_approver_remarks;
      this.providerRemarks = bid.provider_remarks;

      this.seekerInstructions = bid.seeker_instruction;

      this.tripBidEnd = bid.trip_bid_end || 0;
      this.tripCost = bid.trip_cost;
		this.tripCostUsd = bid.trip_cost_usd;
		this.tripCostInr = bid.trip_cost_inr;
      this.tripCostSecondary = bid.trip_cost_secondary;

      this.loiAcceptValidFrom = bid.loi_accept_valid_from;
      this.loiAcceptValidTo = bid.loi_accept_valid_to;

      this.isSentLoiApprover = bid.is_loi_sent_approver;
      this.isLoiApproved = bid.is_loi_sent_approve;

      this.isSentDPHApprover = bid.is_dph_loi_sent_approver;
      this.isDPHApproved = bid.is_dph_loi_sent_approve;

      this.routeCode = bid.routeCode;
      this.transporterCode = bid.transporterCode;

      this.tkResponse = bid.tk_response;
      this.multiModeHeadingCharges = bid.multi_mode_heading_charges || [];
      this.secondarySlabs = bid.slabs || [];
      this.pointOfLoading = bid.point_of_loading;
      this.pointOfDestination = bid.point_of_destination;
      this.estimatedTimeOfDepartureDate = bid.estimated_time_of_departure_date;
      this.estimatedTimeOfArrivalDate = bid.estimated_time_of_arrival_date;
      this.containerFreeDay = bid.container_free_day;
      this.containerDaysHours = bid.container_days_hours;
      this.shippingLineName = bid.shipping_line_name;
      this.bidHistoryStatus = bid.bid_history_status;
      this.bidWhatsapp = bid.bid_whatsapp;
      this.remarks = bid.remarks;
      this.providerType = bid.provider_type;
      this.previousMonthProviderName = bid.previous_month_provider;
      this.previousMonthTaskAllocation = bid.previous_month_task_allocation;
      this.slabCost = bid.slab_cost;
      this.slabOrderText = bid.slab_order_text;
      this.slabColorCode = bid.slab_color_code;
      this.baseOrderText = bid.base_order_text;
      this.bid_remarks = bid.bid_remarks;
      // this.productCategoryType = (bid.product_category || {}).product_category_type;
      // this.productCategoryTypeName = (bid.product_category || {}).product_category_type_name;
      this.showCeilingPriceBeforeBidStart = bid.showCeilingPriceBeforeBidStart || false;
      this.bidPriceReduction= bid.bid_price_reduction;
      this.loiRejectionReason  = bid.loi_rejection_reason;
      this.isWithDrawBid=bid.is_withdraw_bid;
      this.isLTCBid=bid.is_ltc_bid
      this.isAccessBidWithdrawn = bid.is_access_bid_withdrawn;
      this.isApprovalActionAllowed = bid.is_approval_action_allowed;
      this.sumOfProductPrice = bid.sum_of_product_price || '';
      this.sum_price_volume_mt = bid.sum_price_volume_mt || '';
      this.bid_price_volume_mt = bid.bid_price_volume_mt || '';
      this.product_allocation = bid.product_allocation || [];
      this.ltc_order = bid.ltc_order;
      this.ltc_order_text = bid.ltc_order_text;
      this.rfq = bid.rfq;
      this.rfqTypeLtc = bid.rfq_type_ltc;
      this.samePriceOrderText = bid.same_price_order_text;
      this.bidReductionDiff=bid.bid_reduction_diff;
      this.isLOICancelled = bid.is_loi_cancelled;
      this.cancelLoiEnableorDisable= bid.cancel_loi_enable_or_disable || false;
      this.loiCancelRemark = bid.loi_cancel_remark;
      this.samePriceOrderText = bid.same_price_order_text;
      this.quantityCost = bid.quantity_cost || '';
      this.deprecatCost = bid.depreciation_cost || '';
      this.totalCost = bid.total_cost || '';
      this.deprecateOrder = bid.depreciation_order || '';
      this.deprecateOrderText = bid.depreciation_order_text || '';
      this.deprecateColorCode = bid.depreciation_color_code || '';
      this.sumOfProductPrice = bid.sum_of_product_price || '';
      this.cancelLoiSendCount= bid.cancel_loi_send_count || 0;
      this.minimumCountSendToCancelLoi = bid.minimum_count_send_to_cancel_loi;
      this.extraCostPerKmPrice = bid.extra_cost_per_km_price;
      this.extra_cost_cp_state = bid.extra_cost_cp_state;
      this.extra_cost_per_km_cp = bid.extra_cost_per_km_cp;
      this.freight_rate_order_text = bid.freight_rate_order_text;
      this.freight_rate_order = bid.freight_rate_order;
      this.sales_volume_price = bid.sales_volume_price;
      this.bid_approved_status = bid.bid_approved_status || [];
      this.bid_dph_approved_status = bid.bid_dph_approved_status || [];
      this.loi_accepted_date = bid.loi_accepted_date || null;
      this.sub_header_challenge_price = bid.sub_header_challenge_price || '';
      this.header_challenge_price = bid.header_challenge_price || '';
      this.sum_of_header_price = bid.sum_of_header_price || '';
      this.header_cp_state = bid.header_cp_state || '';
      this.sub_header_cp_state = bid.sub_header_cp_state || '';
      this.total_transit_time = bid.total_transit_time || '';
      this.origin_port_free_time = bid.origin_port_free_time || '';
      this.destination_port_free_time = bid.destination_port_free_time || '';
      this.frequency = bid.frequency || '';
      this.ocean_transit_time = bid.ocean_transit_time || '';
      this.transshipment_ports = bid.transshipment_ports || '';
      this.origin_siding = bid.origin_siding || '';
      this.destination_siding = bid.destination_siding || '';
      this.round_trip_count = bid.round_trip_count || 0;
      this.round_bidding_end = bid.round_bidding_end;
      this.round_bidding_start = bid.round_bidding_start;
      this.ipAddress = bid.ip_address;
      this.ipColorCode = bid.ip_color_code;
      this.liner_id = bid.liner_id;
      this.trip_closed = bid.trip_closed;
      this.bid_approved_emails = bid.bid_approved_emails || [];
      this.bid_dph_approved_emails = bid.bid_dph_approved_emails || [];
      this.bid_approver_emails = bid.bid_approver_emails || [];
      this.bid_dph_approver_emails = bid.bid_dph_approver_emails || [];
      this.approval_matrix = bid.approval_matrix || [];
      this.dph_approval_matrix = bid.dph_approval_matrix || [];
      this.bid_approved_status = bid.bid_approved_status || [];
      this.share_of_business_percentage = bid.share_of_business_percentage || '';
      this.sumOfSOB = bid.sumOfSOB || 0;
      this.sub_trip_disposal_product = bid.sub_trip_disposal_product || [];
      this.zone = bid.zone;
      this.depo_name = bid.depo_name;
      this.total_price = bid.total_price;
      this.lot_trip_parent_id = bid.lot_trip_parent_id;
      this.sum_order_text = bid.sum_order_text || '';
      this.sum_order = bid.sum_order;
      this.product_volume_price = bid.product_volume_price;
      this.dph_from_date = bid.dph_from_date || '';
      this.dph_to_date = bid.dph_to_date || '';
      this.dph_percentage = bid.dph_percentage || '';
      this.dph_price_increase = bid.dph_price_increase || '';
      this.current_price = bid.current_price || '';
      this.revised_price = bid.revised_price || '';
      this.loi_rejected_approver = bid.loi_rejected_approver || false;
      this.approver_loi_reject_remarks = bid.approver_loi_reject_remarks || '';
      this.tripContractTenureFrom= bid.trip_contract_tenure_from;
      this.tripContractTenureTo = bid.trip_contract_tenure_to;
      this.tk11_msg= bid.tk11_msg;
      this.tk11_status = bid.tk11_status;
      this.dph_product_volume_price = bid.dph_product_volume_price;
      this.tripBiddingDetails = trip.bidding_and_payments || {};
      this.AverageLPP = trip.average_lpp || '';
      this.bid_reject_status = bid.bid_reject_status || [];
      this.pr_current_amount = bid.pr_current_amount || '';
      this.pr_revised_amount = bid.pr_revised_amount || '';
      this.pr_amount = bid.pr_amount || '';
      this.pr_from_date = bid.pr_from_date || '';
      this.pr_to_date = bid.pr_to_date || '';
      this.pr_amount_increase = bid.pr_amount_increase || '';
      this.pr_remarks = bid.pr_remarks || '';
      this.dph_remarks = bid.dph_remarks || '';
      this.dph_uom = bid.dph_uom;
      this.dph_uom = bid.dph_amount;
      this.additional_cost = bid.additional_cost || false;
      this.cp_error_price = bid.cp_error_price || false;
      this.cp_error_status = bid.cp_error_status || bid.cp_error_message || '';
      this.number_of_vehicle = bid.number_of_vehicle || '';
      this.vehicle_size = bid.vehicle_size || '';
      this.transporter_vehicle = bid.transporter_vehicle || [];
      this.trip_re_bidding = bid.trip_re_bidding;
      this.round_bid_list = bid.round_bid_list || [];
      this.target_price = bid.target_price || '';
      this.over_all_allocation_price = bid.over_all_allocation_price || '';
      this.previous_over_all_allocation_price = bid.previous_over_all_allocation_price || '';
      this.over_all_product_allocation_remarks = bid.over_all_product_allocation_remarks || '';
      this.cp_accept_valid_from = bid.cp_accept_valid_from;
      this.cp_accept_valid_to = bid.cp_accept_valid_to;
      this.bid_approved_status = bid.bid_approved_status || [];
      this.vesselRoutingType = bid.vessel_routing_type
   }
}
